[...document.querySelectorAll('[data-dropdown-wrapper] [class="t4s-dropdown__content"] button, [id="Características"]+span')].forEach(data => {
    if(data.textContent.trim().search(/Características|Caracteristicas/gi) > -1 || data.textContent.trim().search(/Ordenar/g) > -1) {
        data.innerHTML = "ORDENAR";
    }
});



function changeMobileMenu(){
  console.log("Entro!!!!!");
  console.log(document.querySelectorAll('[id="menu-mb__ul"] li[id*="item"]'));
  [...document.querySelectorAll('[id="menu-mb__ul"] li[id*="item"]')].forEach(item => {
    if(item.querySelector('[class="t4s-mb-nav__icon"]')){
      console.log(item);
      let newItem = document.createElement('span');
      newItem.className = "las la-angle-down";
      console.log(item.querySelector('[class="t4s-mb-nav__icon"]'));
      item.querySelector('[class="t4s-mb-nav__icon"]').parentElement.append(newItem);
      item.querySelector('[class="t4s-mb-nav__icon"]').remove();
    }
  });
}


const arrayLinksWithCategoriasDisplay = 
[
  {url:"collections/camisas-y-camisetas-para-hombre",categorie:"camisas-y-camisetas-para-hombre",selectorDescripcion:'[id="description-camisas-y-camisetas-para-hombre"]'},
  {url:"collections/ropa-deportiva-mujer",categorie:"top-categorias-moov-athleisure",selectorDescripcion:'[id="description-moov-athleisure"]'},
  {url:"collections/jeans-y-pantalones-para-mujer",categorie:"top-categorias-jeans-y-pantalones-para-mujer",selectorDescripcion:'[id="description-jeans-y-pantalones-para-mujer"]'},
  {url:"collections/vestidos-de-bano",categorie:"top-categorias-swimwear",selectorDescripcion:'[id="description-swimwear"]'},
  {url:"collections/camisas-y-camisetas",categorie:"top-categorias-camisas-camisetas",selectorDescripcion:'[id="description-camisas-camisetas"]'},
  {url:"collections/crop-tops",categorie:"top-categorias-crop-tops",selectorDescripcion:'[id="description-crop-tops"]'},
  {url:"collections/buzos-y-chaquetas",categorie:"top-categorias-buzos-chaquetas",selectorDescripcion:'[id="description-buzos-chaquetas"]'},
  {url:"collections/faldas-y-shorts",categorie:"top-categorias-faldas-shorts",selectorDescripcion:'[id="description-faldas-shorts"]'},
  {url:"collections/vestidos-y-enterizos",categorie:"top-categorias-vestidos",selectorDescripcion:'[id="description-vestidos"]'},
  {url:"collections/packs-one-half",categorie:"top-categorias-packs",selectorDescripcion:'[id="description-packs"]'},
  {url:"collections/accesorios-y-complementos",categorie:"top-categorias-accesorios",selectorDescripcion:'[id="description-accesorios"]'},
  {url:"collections/ropa-en-descuento-mujer",categorie:"top-categorias-sale",selectorDescripcion:'[id="description-sale"]'},
  {url:"collections/ropa-interior-mujer",categorie:"top-categorias-intimates",selectorDescripcion:'[id="description-intimates"]'},
  {url:"collections/nuevo",categorie:"top-categorias-lo-nuevo",selectorDescripcion:'[id="description-lo-nuevo"]'},
  {url:"collections/tops-deportivos",categorie:"top-categorias-tops"},
  {url:"collections/panties-swimwear",categorie:"top-categorias-bottoms"},
  {url:"collections/ultimas-unidades",categorie:"top-categorias-ultimas-unidades",selectorDescripcion:'[id="description-ultimas-unidades"]'},
  {url:"collections/knit-pieces",categorie:"top-categorias-knit-pieces",selectorDescripcion:'[id="description-knit-pieces"]'},
  {url:"collections/essentials",categorie:"top-categorias-essentials",selectorDescripcion:'[id="description-essentials"]'},
  {url:"collections/ver-todo",categorie:"todos-los-productos",selectorDescripcion:'[id="description-todos-los-productos"]'},
  {url:"collections/best-sellers",categorie:"best-sellers",selectorDescripcion:'[id="description-best-sellers"]'},
  {url:"collections/gift-card",categorie:"gift-card",selectorDescripcion:'[id="description-gift-card"]'},
  {url:"collections/accesorios-para-hombre",categorie:"accesorios-hombre",selectorDescripcion:'[id="description-accesorios-para-hombre"]'},
  {url:"collections/jeans-y-pantalones-para-hombre",categorie:"top-cateogorias-jeans-y-pantalones-para-hombre",selectorDescripcion:'[id="description-jeans-y-pantalones-para-hombre"]'},
  {url:"collections/todos-los-productos-masculino",categorie:"top-todos-los-productos-masculino",selectorDescripcion:'[id="description-todos-los-productos-masculino"]'},
  {url:"collections/prendas-unisex",categorie:"top-prendas-unisex",selectorDescripcion:'[id="description-prendas-unisex"]'},
  {url:"collections/enterizos-deportivos",categorie:"top-enterizos-deportivos",selectorDescripcion:'[id="description-enterizos-deportivos"]'},
  {url:"collections/inferiores-deportivos",categorie:"top-inferiores-deportivos",selectorDescripcion:'[id="description-inferiores-deportivos"]'},
  {url:"collections/crop-tops-deportivos",categorie:"top-crop-tops-deportivos",selectorDescripcion:'[id="description-crop-tops-deportivos"]'},
  {url:"collections/camisas-camisetas-y-crop-tops",categorie:"top-camisas-camisetas-y-crop-tops",selectorDescripcion:'[id="description-camisas-camisetas-y-crop-tops"]'},
  {url:"collections/vestidos-y-faldas",categorie:"top-vestidos-y-faldas",selectorDescripcion:'[id="description-vestidos-y-faldas"]'},
  {url:"collections/medias",categorie:"top-medias",selectorDescripcion:'[id="description-medias"]'},
];

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(() => {
        const arrayFiltersElements = document.querySelectorAll('[id="FacetFiltersForm"] a');
        arrayFiltersElements.forEach(item => {
          if(!item.href.includes('availability')) item.href = item.href+'&filter.v.availability=1';
        });
  }, "1000");
  
  setTimeout(() => {
        document.querySelector('#menu-mb__ul li a[href*="ropa-en-descuento-mujer"]').id = "sale-properties";
  }, "3000");
 
  setTimeout(() => {
    changeMobileMenu();
  }, "5000");
  
  cargarMenus();
  
  
  let locationWindow = window.location.href.trim();
  locationWindow = locationWindow.replaceAll("https://onehalf.com.co","").trim();
  if(locationWindow.includes('?')) locationWindow = locationWindow.split('?')[0].trim();
  if(locationWindow.includes('/')) locationWindow = locationWindow.split('/')[1].trim();
  
  if(locationWindow != ""){
    document.querySelector('img[class*="header__normal-logo"]').src = "https://cdn.shopify.com/s/files/1/0257/9981/9345/files/Logo_negro_One_Half_0f67e212-b423-472b-a3b2-9cddc13eb593.png?v=1722875949";
    document.querySelector('img[class*="header__mobile-logo"]').src = "https://cdn.shopify.com/s/files/1/0257/9981/9345/files/Logo_negro_One_Half_0f67e212-b423-472b-a3b2-9cddc13eb593.png?v=1722875949";
    document.querySelector('img[class*="header__sticky-logo"]').src = "https://cdn.shopify.com/s/files/1/0257/9981/9345/files/Logo_negro_One_Half_0f67e212-b423-472b-a3b2-9cddc13eb593.png?v=1722875949";
  }

  let windowLocation = window.location.href.trim();
  windowLocation = windowLocation.replaceAll(/https:\/\/onehalf.com.co\/?/gi,'').split('?')[0].trim()
  if(windowLocation !== ""){
      let navigationHome = document.querySelector('[id="navigation-custom-home"]');
      if(navigationHome) navigationHome.style.display = "none";
      if(document.querySelector('[id="navigation-custom-home"] [class="scrollmenu"]')) document.querySelector('[id="navigation-custom-home"] [class="scrollmenu"]').scrollLeft += 30;
  }
});


function cargarMenus() {
  arrayLinksWithCategoriasDisplay.forEach( data =>{
    const currentURL = window.location.href.trim();
    if(currentURL.indexOf(data.url)>-1){
      if(data.selectorDescripcion){
        console.log(document.querySelector(data.selectorDescripcion));
        if(document.querySelector(data?.selectorDescripcion)) document.querySelector(data?.selectorDescripcion).style.display = "";
        if(document.querySelector('[id="ver-mas-menos-custom"]')) document.querySelector('[id="ver-mas-menos-custom"]').style.display = "";
      }
      //if(document.querySelector("[id='"+data.categorie+"']")) document.querySelector("[id='"+data.categorie+"']").style.display = "";
    }
  });
}





//function nextItemSubMenuMobile(){
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(-10px, 0px, 0px)";
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(-20px, 0px, 0px)";
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(-30px, 0px, 0px)";
//}

//function previousItemSubMenuMobile(){
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(+"+(contador-20)+"px, 0px, 0px)";
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(+"+(contador-10)+"px, 0px, 0px)";
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(+"+(contador-5)+"px, 0px, 0px)";
//}



























